import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { SaveNewPhotoFrameWSREModelRequest } from '../../models/wsre.model';
import { WsreService } from '../../wsre.service';
import { heicTo } from 'heic-to';

@Component({
  selector: 'upload-photo-wsre-frame',
  templateUrl: './upload-photo-wsre-frame.component.html',
  styleUrls: ['./upload-photo-wsre-frame.component.scss']
})
export class UploadPhotoWsreFrameComponent implements OnInit {
  @Input() uploadEndPoint: number;
  @Input() relatedId: number;
  @Input() componentId:number;
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();

  photo = '';
  photoLoading = false;
  constructor(private _wsreService: WsreService,
    private _notify: NotificationsService,) { }

  ngOnInit() {
  }

  sucessfullyUploaded(title: string, message: string, image: string) {
    this._notify.success(title, message);
    this.onPhotoUpload.emit(true);
  }
  errorMessage() {
    this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
  }

  resizeBase64Img(base64, newWidth, newHeight) {
    return new Promise((resolve, reject)=>{
        var canvas = document.createElement("canvas");
        canvas.style.width = newWidth.toString()+"px";
        canvas.style.height = newHeight.toString()+"px";
        let context = canvas.getContext("2d");
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
            context.scale(newWidth/img.width,  newHeight/img.height);
            context.drawImage(img, 0, 0); 
            resolve(canvas.toDataURL());               
        }
    });
}

uploadPhoto(newPhoto: string) {
  this.photoLoading = true;
//  let IdlarPartImage =  new IdlerPartImageReqVM();

  switch (+this.uploadEndPoint) {
 
   case 3:
     const _ArrivalPhoto =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto, 1);
     this._wsreService.SaveArrivalPhotoFrame(_ArrivalPhoto).subscribe(r => {
       this.photoLoading = false;
       if ( r >= 0) {
         this.sucessfullyUploaded('Uploaded', 'Arrival photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;
  case 17:
    const _finalPhoto =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,1);
    this._wsreService.SaveFinalPhotoFrame(_finalPhoto).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Final photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;
   case 4:
     const _customerReferencePhoto =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,1);
     this._wsreService.SaveCustomerReferencePhotosFrame(_customerReferencePhoto).subscribe(r => {
       this.photoLoading = false;
       if ( r >= 0) {
         this.sucessfullyUploaded('Uploaded', 'Customer Reference photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;
   case 5:
     const _oldTagPhoto =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,1);
     this._wsreService.SaveOldTagPhotosFrame(_oldTagPhoto).subscribe(r => {
       this.photoLoading = false;
       if ( r >= 0) {
         this.sucessfullyUploaded('Uploaded', 'Old Tag photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;
   case 11:
     const _failedIronPhoto =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,1);
     this._wsreService.SaveFailedIronPhotosFrame(_failedIronPhoto).subscribe(r => {
       this.photoLoading = false;
       if ( r >= 0) {
         this.sucessfullyUploaded('Uploaded', 'Failed Iron photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;

   //right side photos
   case 6:
    const _ArrivalPhoto_R =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto, 2);
    this._wsreService.SaveArrivalPhotoFrame(_ArrivalPhoto_R).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Arrival photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;
   case 7:
    const _finalPhoto_R =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,2);
    this._wsreService.SaveFinalPhotoFrame(_finalPhoto_R).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Arrival photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;
   case 8:
    const _customerReferencePhoto_R =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,2);
    this._wsreService.SaveCustomerReferencePhotosFrame(_customerReferencePhoto_R).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Customer Reference photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;
   case 9:
    const _oldTagPhoto_R =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,2);
    this._wsreService.SaveOldTagPhotosFrame(_oldTagPhoto_R).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Old Tag photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;

  case 12:
     const _failedIronPhoto_R =  new SaveNewPhotoFrameWSREModelRequest(this.relatedId, newPhoto,2);
     this._wsreService.SaveFailedIronPhotosFrame(_failedIronPhoto_R).subscribe(r => {
       this.photoLoading = false;
       if ( r >= 0) {
         this.sucessfullyUploaded('Uploaded', 'Failed Iron photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;

  case 10:
    const _ComponentPhotFrame =  new SaveNewPhotoFrameWSREModelRequest(0, newPhoto,this.componentId);
    this._wsreService.SaveUpdateFrameComponentImage(_ComponentPhotFrame).subscribe(r => {
      this.photoLoading = false;
      if ( r >= 0) {
        this.sucessfullyUploaded('Uploaded', 'Component photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;

     default: break;
  }
}

// onSelectPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     const reader = new FileReader();
//     reader.readAsDataURL(event.target.files[0]);
//     reader.onload = (event: any) => {
//       const imageUrl = (event.target["result"]);
//       //resize photo
//       this.compressImage(imageUrl).then((res: string) => {
//         // console.log("imageUrl", res)
//         if (res) {
//          //console.log('res', res)

//           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
//           this.uploadPhoto(res.split(',')[1]);
//         }
//       })
//       //this.uploadPhoto(event.target.result.split(',')[1]);
//     };
//   }
// }

  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(f);
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl).then((res: string) => {
  //           if (res) {
  //             this.uploadPhoto(res.split(',')[1]);
  //           }
  //         });
  //       };
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         console.error("HEIC conversion failed", err);
  //         alert("Unable to process HEIC image");
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  async onSelectPhoto(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.uploadPhoto(res.split(',')[1]);
          }

        })
        .catch(err => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.photoLoading = false;

    alert("Unable to process HEIC image");

  }

  // Allow selecting the same file again
  event.target.value = null;

}
private compressImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      let width, height;
      width = img.width;
      height = img.height;
      console.log('width', width)
      console.log('height', height)
      var ratio = height / width; //cal aspect ratio
      let imageWidth = 800;//643
      var new_height = imageWidth * ratio; //calculate new height
      elem.width = imageWidth;
      elem.height = new_height;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, imageWidth, new_height);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}
}
